var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import Form from './Form';
import { useEffect, useState } from 'react';
var Forms = function (_a) {
    var fetchFormResult = _a.fetchFormResult;
    var _b = __read(useState([]), 2), data = _b[0], setData = _b[1];
    useEffect(function () {
        if (fetchFormResult) {
            fetchFormResult()
                .then(function (res) {
                setData(res);
            })
                .catch(console);
        }
    }, [fetchFormResult]);
    return (_jsx(_Fragment, { children: data.map(function (item, index) { return (_jsx(Form, __assign({}, item), index)); }) }));
};
export default Forms;
